import React from 'react'
import System from 'src/helper/system';

const NoContent = () => {
    const { translation:t } = System;
    return (
        <>
            <div className="no-result-found text-uppercase">
                {t('noResultsFound')}
            </div>
        </>
    )
}

export default NoContent